import { useNavigation } from '@/app/hooks'
import { InProgressUtilityProgramUnenrollment } from '@/reducers/inProgressUtilityProgramUnenrollments'
import { UtilityProgram } from '@/types/utilityProgram'
import { useState } from 'react'
import { getDeviceSelectionForSuggestionPresentation } from '../utils'

export type Props = {
  deviceSelection: InProgressUtilityProgramUnenrollment['deviceSelection']
  selectedReasons: NonNullable<
    InProgressUtilityProgramUnenrollment['unenrollmentReasons']
  >
  utilityProgram: UtilityProgram
}

export default function useViewModel(props: Props) {
  const { deviceSelection, selectedReasons } = props
  const navigation = useNavigation()

  /**
   * We use this to track which signals have been loaded so we can determine if
   * all the data has been loaded. When we have a loading signal for each
   * expected device type, we can determine all the data has been loaded.
   */
  const [loadedSignals, setLoadedSignals] = useState<Record<string, boolean>>(
    {},
  )

  const makeLoadedSignalSetter = (key: string) => (loaded: boolean) => {
    setLoadedSignals((prev) => ({ ...prev, [key]: loaded }))
  }

  const deviceSelectionForPresentation =
    getDeviceSelectionForSuggestionPresentation(
      deviceSelection,
      selectedReasons,
      props.utilityProgram,
    )

  const expectedLoadingSignalCount = deviceSelectionForPresentation
    .map((d) => d.ids)
    .flat().length

  const isLoaded =
    Object.values(loadedSignals).filter(Boolean).length ===
    expectedLoadingSignalCount

  const onStayInProgramClick = () => {
    navigation.goHome()
  }
  const onUnenrollClick = () => {
    navigation.push(
      `/utility-program/${props.utilityProgram.id}/unenroll/feedback`,
    )
  }

  return {
    deviceSelectionForPresentation,
    makeLoadedSignalSetter,
    isLoadingOrIdle: !isLoaded,
    onUnenrollClick,
    onStayInProgramClick,
  }
}
